import { addHours, addMinutes, startOfDay, subMinutes } from 'date-fns';
import { useOutletSite } from 'hooks/useOutletSite/useOutletSite';
import { usePlutoApiQuery } from 'hooks/useQuery/plutoApi';
import { fetchAssetStatesDataGapAndSubscribe } from 'pages/Operations/data';
import {
  GET_ASSET_OPERATIONS_STATES,
  GET_ASSET_OPERATIONS_SUMMARY,
} from 'pages/Operations/queries';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { useStore } from 'store';
import { findSite } from 'utils/site';

export const AssetOperations = () => {
  const [date, hoveredDate, nowMode] = useStore((state) => [
    state.currentDate,
    state.hoveredDate,
    state.nowMode,
  ]);

  const { site: siteId, asset: assetId } = useParams();
  const start = useMemo(
    () => (nowMode ? subMinutes(new Date(), 5) : startOfDay(date)),
    [date, nowMode],
  );
  const { data: outletData } = useOutletSite();

  const [breadCrumbSite, setBreadCrumbSite] = useState(
    findSite(outletData?.company?.sites, siteId),
  );

  const [breadCrumbLoading, setBreadCrumbLoading] = useState(false);

  const queryVariables = useMemo(
    () => ({
      assetId: Number(assetId),
      start,
      end: nowMode ? addMinutes(start, 5) : addHours(start, 24),
    }),
    [assetId, start, nowMode],
  );

  const { data: assetSummary, loading: assetSummaryLoading } = usePlutoApiQuery(
    GET_ASSET_OPERATIONS_SUMMARY,
    {
      variables: queryVariables,
      fetchPolicy: nowMode ? 'network-only' : 'cache-first',
    },
  );

  const {
    client: apolloClient,
    data,
    loading,
    subscribeToMore,
    fetchMore,
  } = usePlutoApiQuery(GET_ASSET_OPERATIONS_STATES, {
    variables: queryVariables,
    fetchPolicy: nowMode ? 'network-only' : 'cache-first',
  });

  const asset = useMemo(() => assetSummary?.asset, [assetSummary]);
  const states = data?.asset?.states;
  const isLoading = loading && assetSummaryLoading;

  useEffect(() => {
    if (!outletData?.company?.sites) {
      setBreadCrumbLoading(true);
    }
    if (outletData?.company?.sites && siteId) {
      setBreadCrumbLoading(false);
      setBreadCrumbSite(findSite(outletData?.company?.sites, siteId));
    }
  }, [outletData, siteId]);

  useEffect(() => {
    if (isLoading || !start || !assetId) {
      return;
    }
    let onUnsubscribe = () => {};

    (async () => {
      onUnsubscribe = await fetchAssetStatesDataGapAndSubscribe({
        apolloClient,
        queryVariables,
        fetchMore,
        subscribeToMore,
        nowMode,
      });
    })();

    return () => onUnsubscribe();
  }, [
    assetId,
    start,
    isLoading,
    queryVariables,
    fetchMore,
    subscribeToMore,
    nowMode,
  ]);

  if (!assetId) {
    return null;
  }

  return <div>Asset Operations</div>;
};
